import React, { Component } from 'react'
import {
  Header,
  Footer,
  Card,
  PageWrapper,
  ListView,
  Arrow,
  XMText,
  FlexWrapper,
  Icon,
  XXLText,
  ProgressBar,
  StyledFlex,
  Modal,
  TextField,
  FormikForm,
  StyledImage,
  Button,
  TextOverflow,
  WarningCard
} from '../components'
import { addList } from '../utlis/validators'
import { getAverageData, roundingValue } from '../utlis/functions'
import qs from 'qs'
import Cookies from 'js-cookie'
import { API_URL } from '../constants'
import axios from 'axios'
import { get, sum, forEach, min, max, isEmpty } from 'lodash'
import { Formik, Field } from 'formik'

class List extends Component {
  state = {
    shoppingLists: [],
    showModal: false,
    grocerWarningCard: false,
    toggleImage: {}
  }
  fetchUserLists = async () => {
    try {
      const query = {
        filter: {
          include: [{ products: { product: ['productCost'] } }]
        }
      }
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/shoppingLists?${qs.stringify(query)}`
      )

      await this.setState({ shoppingLists: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }

  fetchUserGrocer = async () => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id') }
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserGrocers?${qs.stringify(query)}`)
      this.setState({ userGrocer: data })
      if (data.length === 0) {
        this.setState({ grocerWarningCard: true })
      }
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  async componentDidMount() {
    window.scrollTo(0, 0)
    await this.fetchUserGrocer()
    await this.fetchUserLists()
  }

  handleToggle = key => {
    let toggleImage = this.state.toggleImage
    toggleImage[key] = !toggleImage[key]
    this.setState({ toggleImage: toggleImage })
  }

  getTotalPrice = data => {
    let total = {}
    let lowerTotalPrice = 0
    let upperTotalPrice = 0
    let asterisk = 0
    data.forEach(item => {
      const priceRange = get(item, 'product.productCost', []).map(ite => {
        if (!ite.productPriceOriginal) asterisk++
        return ite.productPriceSale
          ? ite.productPriceSale * item.quantity
          : ite.productPriceOriginal
          ? ite.productPriceOriginal * item.quantity
          : 'NaN'
      })
      lowerTotalPrice += min(priceRange) === 'NaN' ? 0 : min(priceRange)
      upperTotalPrice += max(priceRange) === 'NaN' ? 0 : max(priceRange)
      total = {
        lowerTotalPrice: roundingValue(lowerTotalPrice),
        upperTotalPrice: roundingValue(upperTotalPrice),
        asterisk
      }
    })
    return total
  }

  render() {
    const { shoppingLists, showModal, grocerWarningCard, toggleImage } = this.state
    return (
      <React.Fragment>
        <Header
          title="Your Shopping Lists"
          showProfile
          onClickProfile={() => this.props.history.push('/user-profile')}
        />

        <PageWrapper viewPadding="22.4% 4.3%" height="auto" modifyPadding="80px 16px 84px">
          {grocerWarningCard && get(this.state, 'userGrocer', []).length === 0 && (
            <WarningCard
              onClickCard={() => this.props.history.push('/dashboard/shop/edit')}
              onClose={() => this.setState({ grocerWarningCard: false })}
              text="Where do you like to shop? Help us find the best stores for you."
            />
          )}
          <Card
            boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
            borderRadius="5px"
            bgColor="#fff"
            height="auto"
            padding={'12px 0'}>
            <ListView
              hideTop={
                <FlexWrapper
                  direction="row"
                  alignItems="center"
                  viewPadding="0 16px 12px"
                  width="100%"
                  style={{ borderBottom: '0.5px solid #dcdcdc' }}
                  onClick={async () => {
                    await this.setState({ showModal: false, listExist: false })
                    this.setState({ showModal: true, createNew: true })
                  }}>
                  <FlexWrapper viewMargin="0 6px 0 0" flexBasis="6%">
                    <Icon icon="add" width={16} height={16} />
                  </FlexWrapper>
                  <XXLText textAlign="left" color="#124b5f">
                    Create New List
                  </XXLText>
                </FlexWrapper>
              }
              component={shoppingLists.map(list => {
                const showImageComponent = toggleImage[list.id] ? true : false
                return (
                  <React.Fragment key={list.id}>
                    <FlexWrapper direction="row" alignItems="center" viewPadding="0px 16px">
                      <ProgressBar
                        onClick={() => this.handleToggle(list.id)}
                        flex
                        percentage={
                          getAverageData(get(list, 'products', 0)) === 'NaN'
                            ? 0
                            : getAverageData(get(list, 'products', 0))
                        }
                        initialAnimation={true}
                        strokeWidth={16}
                        size="52px"
                        childComponent={
                          !showImageComponent && (
                            <StyledImage
                              src={get(
                                list.products[0],
                                'product.productImage',
                                require('../static/images/empty-list.png')
                              )}
                              height="32px"
                              maxWidth="32px"
                              style={{ position: 'absolute', borderRadius: '50%' }}
                              background="#fff"
                            />
                          )
                        }
                      />
                      <StyledFlex
                        direction="row"
                        viewMargin="0 0 0 20px"
                        viewPadding="16px 0 10px 0"
                        alignItems="center"
                        height="70px"
                        justifyContent="space-between"
                        onClick={() => this.props.history.push(`/lists/${list.id}`)}>
                        <TextOverflow maxWidth="200px">
                          <XXLText
                            textAlign="left"
                            color="#124b5f"
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '120px'
                            }}>
                            {list.name}
                          </XXLText>
                          <FlexWrapper direction="row" alignItems="center">
                            <XMText color="#9f9f9f">
                              {sum(get(list, 'products', []).map(item => item.quantity)) || 0} items
                            </XMText>

                            <XMText color="#9f9f9f" padding="0 0 0 2px">
                              |
                            </XMText>
                            <XMText color="#078489" fontWeight="600" padding="0 0 0 2px">
                              $
                              {isEmpty(this.getTotalPrice(get(list, 'products', [])))
                                ? '00.00'
                                : get(this.getTotalPrice(get(list, 'products', [])), 'lowerTotalPrice', '') ===
                                  get(this.getTotalPrice(get(list, 'products', [])), 'upperTotalPrice', '')
                                ? get(this.getTotalPrice(get(list, 'products', [])), 'upperTotalPrice', '')
                                : `${get(this.getTotalPrice(get(list, 'products', [])), 'lowerTotalPrice', '')} - ${get(
                                    this.getTotalPrice(get(list, 'products', [])),
                                    'upperTotalPrice',
                                    ''
                                  )}`}
                              {get(this.getTotalPrice(get(list, 'products', [])), 'asterisk', '') > 0 ? '*' : ''}
                            </XMText>
                          </FlexWrapper>
                        </TextOverflow>
                        <Arrow color="#124b5f" rotate="225" />
                      </StyledFlex>
                    </FlexWrapper>
                  </React.Fragment>
                )
              })}
            />
          </Card>
        </PageWrapper>
        <Footer />
        <Modal
          title={'Create New List'}
          show={showModal}
          hide={!showModal}
          // list={openList || listExist}
          onClose={() => this.setState({ showModal: false })}>
          <FlexWrapper alignItems="center">
            <React.Fragment>
              <Formik
                enableReinitialize
                initialValues={{ title: '' }}
                validate={addList}
                validateOnChange
                onSubmit={async val => {
                  try {
                    const { data } = await axios.post(`${API_URL}/users/${Cookies.get('user_id')}/shoppingLists`, {
                      name: val.title,
                      userId: Cookies.get('user_id')
                    })
                    await this.setState({ showModal: false, createNew: false })
                    this.fetchUserLists()
                    // await this.setState({ listExist: true, showModal: true })
                    console.log('DATA LIST', data)
                  } catch (error) {
                    console.log('ERROR', error)
                  }
                }}
                render={formikBag => (
                  <FormikForm>
                    <Field
                      name="title"
                      render={({ field }) => (
                        <TextField {...field} width="auto" type="text" label="Title" error={formikBag.errors.title} />
                      )}
                    />
                    <FlexWrapper alignItems="center">
                      <Button
                        size="small"
                        label="Add"
                        namespace="Create List"
                        volume="filled"
                        margin="14px 0 0 0"
                        type="submit"
                      />
                    </FlexWrapper>
                  </FormikForm>
                )}
              />
            </React.Fragment>
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}

export default List



// WEBPACK FOOTER //
// ./src/pages/List.js